import React, { Component } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DomainIcon from "@mui/icons-material/Domain";
import GroupIcon from "@mui/icons-material/Group";
import { Link } from "react-router-dom";
import CollapsibleList from "common/components/CollapsibleList";
import MapIcon from "@mui/icons-material/Map";
import StoreIcon from "@mui/icons-material/Store";
import FolderIcon from "@mui/icons-material/Folder";
import LabelIcon from "@mui/icons-material/Label";
import {
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import LocationCity from "@mui/icons-material/LocationCity";

class SuperadminNavLinks extends Component {
  state = {
    active: null,
  };

  isActive = (list) => list === this.state.active;

  setActive = (list) => {
    if (this.isActive(list)) {
      this.setState({ active: null });
    } else {
      this.setState({ active: list });
    }
  };

  render() {
    return (
      <List component="nav">
        <ListItemButton component={Link} to="/">
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItemButton>
        <Divider />
        <CollapsibleList
          heading="Cities"
          icon={<LocationCity />}
          onClick={() => this.setActive("Cities")}
          expanded={this.isActive("Cities")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/cities">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Cities" />
            </ListItemButton>
            <ListItemButton component={Link} to="/cities/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a City" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <CollapsibleList
          heading="Neighborhoods"
          icon={<MapIcon />}
          onClick={() => this.setActive("Neighborhoods")}
          expanded={this.isActive("Neighborhoods")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/neighborhoods">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Neighborhoods" />
            </ListItemButton>
            <ListItemButton component={Link} to="/neighborhoods/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a Neighborhood" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <CollapsibleList
          heading="Buildings"
          icon={<DomainIcon />}
          onClick={() => this.setActive("Buildings")}
          expanded={this.isActive("Buildings")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/buildings">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Buildings" />
            </ListItemButton>
            <ListItemButton component={Link} to="/buildings/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a Building" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <CollapsibleList
          heading="Businesses"
          icon={<StoreIcon />}
          onClick={() => this.setActive("Businesses")}
          expanded={this.isActive("Businesses")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/businesses">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Businesses" />
            </ListItemButton>
            <ListItemButton component={Link} to="/businesses/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a Business" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <CollapsibleList
          heading="Categories"
          icon={<FolderIcon />}
          onClick={() => this.setActive("Categories")}
          expanded={this.isActive("Categories")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/categories">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Categories" />
            </ListItemButton>
            <ListItemButton component={Link} to="/categories/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a Category" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <ListItemButton component={Link} to="/superquicklinks">
          <ListItemIcon>
            <ListIcon />
          </ListItemIcon>
          <ListItemText primary="Quick Links" />
        </ListItemButton>
        <CollapsibleList
          heading="Food Order Providers"
          icon={<FolderIcon />}
          onClick={() => this.setActive("Food Order Providers")}
          expanded={this.isActive("Food Order Providers")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/foodorder">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Food Order Providers" />
            </ListItemButton>
            <ListItemButton component={Link} to="/foodorder/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a Food Order Provider" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <Divider />
        <CollapsibleList
          heading="Users"
          icon={<GroupIcon />}
          onClick={() => this.setActive("Users")}
          expanded={this.isActive("Users")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/users">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Users" />
            </ListItemButton>
            <ListItemButton component={Link} to="/users/add">
              <ListItemIcon>
                <AddCircleOutline />
              </ListItemIcon>
              <ListItemText primary="Add a User" />
            </ListItemButton>
          </List>
        </CollapsibleList>
        <CollapsibleList
          heading="Offers"
          icon={<LabelIcon />}
          onClick={() => this.setActive("Offers")}
          expanded={this.isActive("Offers")}
        >
          <List component="div" disablePadding>
            <ListItemButton component={Link} to="/offers">
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="View Offers" />
            </ListItemButton>
          </List>
        </CollapsibleList>
      </List>
    );
  }
}

export default SuperadminNavLinks;
